import { removeHeaderToken, setHeaderToken } from "../utils/auth";

export default {
    state: {
        user: null,
        isLoggedIn: false
    },
    // Untuk menyimpan, mengubah atau memanipulasi state kita gunakan.
    mutations: {
        set_user(state, data) {
            state.user = data
            state.isLoggedIn = true
        },
        reset_user(state) {
            state.user = null
            state.isLoggedIn = false
        }
    },
    // Untuk mengakses properti state yang akan kita gunakan untuk melakukan kueri pada komponen yang kita buat
    getters: {
        isLoggedIn(state) {
            return state.isLoggedIn
        },
        user(state) {
            return state.user
        }
    },
    // Kita buat promise request axios method post ke endpoint login pada method login. Jika request suskses
    // Kita simpan response data token pada local storage, header, dan dispatch method get_user.
    actions: {
        login({ dispatch, commit }, data) {
            return new Promise(
                (resolve, reject) => {
                    axios.post('/api/auth/login', data)
                    .then(response => {
                        const token = response.data.metadata.token
                        localStorage.setItem('token', token)
                        setHeaderToken(token)
                        dispatch('get_user')
                        resolve(response)
                    })
                    .catch(
                        err => {
                            commit('reset_user')
                            localStorage.removeItem('token')
                            reject(err)
                        }
                    )
                }
            )
        },
        async get_user({ commit }) {
            if (!localStorage.getItem('token')) {
                return '';
            }
            try {
                let response = await axios.get('/api/users')
                commit('set_user', response.data.data)
            } catch (error) {
                commit('reset_user')
                removeHeaderToken()
                localStorage.removeItem('token')
                return error
            }
        },
        logout({ commit }) {
            return new Promise((resolve) => {
                commit('reset_user')
                localStorage.removeItem('token')
                removeHeaderToken()
                resolve()
            })
        }
    }
};
